/* Modello homepage: slidere (hero, colecții, galerie). Fără biblioteci; merge și în editorul de teme. */
(function () {
  function init(root) {
    if (root.__mh) return;
    root.__mh = true;
    var mode = root.getAttribute('data-mh-slider');
    var auto = parseFloat(root.getAttribute('data-mh-auto') || '0');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mh-item]'));
    var noEls = Array.prototype.slice.call(root.querySelectorAll('[data-mh-no]'));
    var bar = root.querySelector('[data-mh-bar]');
    var strip = root.querySelector('[data-mh-strip]');
    var steps = mode === 'strip' ? Math.max(1, parseInt(root.getAttribute('data-mh-steps') || '1', 10)) : items.length;
    if (root.classList.contains('mh-hero') && items[0]) {
      document.body.setAttribute('data-mh-tone', items[0].getAttribute('data-tone') || 'light');
      document.body.setAttribute('data-mh-text', items[0].getAttribute('data-text') || 'on');
    }
    if (steps < 2) return;
    var i = 0;
    var timer = null;
    var visible = true;
    var wait = false;

    /* colecții: dacă secțiunea e mai jos pe pagină, prima poză intră în scenă abia când ajunge omul la ea, ca mișcarea să se vadă clar */
    if (root.classList.contains('mh-col') && mode === 'fade' && 'IntersectionObserver' in window &&
        !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var r0 = root.getBoundingClientRect();
      var vh0 = window.innerHeight || document.documentElement.clientHeight;
      if (!(r0.top < vh0 * 0.6 && r0.bottom > vh0 * 0.2)) {
        wait = true;
        var arrive = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) {
            wait = false;
            arrive.disconnect();
            setTimeout(function () { render(); start(); }, 60);
          }
        }, { threshold: 0.3 });
        arrive.observe(root);
      }
    }

    function pad(n) { return (n + 1 < 10 ? '0' : '') + (n + 1); }

    function render() {
      if (mode === 'fade') {
        items.forEach(function (el, k) { el.classList.toggle('is-active', k === i && !wait); });
        if (root.classList.contains('mh-hero') && items[i]) {
          document.body.setAttribute('data-mh-tone', items[i].getAttribute('data-tone') || 'light');
          document.body.setAttribute('data-mh-text', items[i].getAttribute('data-text') || 'on');
        }
      } else if (strip && items.length) {
        var step = items[1] ? items[1].offsetLeft - items[0].offsetLeft : items[0].offsetWidth;
        strip.style.transform = 'translateX(' + (-i * step) + 'px)';
      }
      noEls.forEach(function (el) { el.textContent = pad(i); });
      if (bar) bar.style.width = ((i + 1) / steps) * 100 + '%';
    }

    function go(n) { i = (n + steps) % steps; render(); }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!(auto > 0)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () {
        if (!root.isConnected) { stop(); return; }
        if (visible && !document.hidden && !wait) go(i + 1);
      }, auto * 1000);
    }

    /* pot fi mai multe seturi de butoane (de ex. câte unul sub textul fiecărei colecții): le legăm pe toate */
    Array.prototype.forEach.call(root.querySelectorAll('[data-mh-prev]'), function (b) { b.addEventListener('click', function () { go(i - 1); start(); }); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-mh-next]'), function (b) { b.addEventListener('click', function () { go(i + 1); start(); }); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
    }
    window.addEventListener('resize', function () { if (mode === 'strip') render(); });
    render();
    start();
  }

  function parallax(hero) {
    if (hero.__mhp) return;
    hero.__mhp = true;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    var visible = true;
    function update() {
      ticking = false;
      if (!visible || !hero.isConnected) return;
      var top = hero.getBoundingClientRect().top;
      hero.style.setProperty('--mh-ps', Math.max(0, -top).toFixed(1));
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) onScroll(); }, { threshold: 0 }).observe(hero);
    }
    update();
  }

  function clouds(hero) {
    if (hero.__mhc) return;
    hero.__mhc = true;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var layers = Array.prototype.slice.call(hero.querySelectorAll('.mh-cloudwrap'));
    if (!layers.length) return;
    var offs = layers.map(function () { return 0; });
    var last = null;
    hero.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var r = hero.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      var inZone = x < r.width * 0.5 && y < r.height * 0.72;
      if (!inZone) { last = null; return; }
      if (last !== null) {
        var dx = e.clientX - last;
        layers.forEach(function (l, i) {
          var photo = l.classList.contains('mh-cloudwrap--photo');
          var k = photo ? 0.12 : (l.classList.contains('mh-cloudwrap--near') ? 0.34 : 0.16);
          var lim = photo ? 38 : 260;   // norii din poză se mută puțin: rămân aceiași nori, departe de om
          offs[i] = Math.max(-lim, Math.min(lim, offs[i] + dx * k));
          var c = l.querySelector('.mh-clouds');
          if (c) c.style.setProperty('--mh-cx', offs[i].toFixed(1));
        });
      }
      last = e.clientX;
    });
    hero.addEventListener('pointerleave', function () { last = null; });
  }

  function rail(root) {
    if (root.__mhr) return;
    root.__mhr = true;
    var r = root.querySelector('[data-mh-rail]');
    if (!r) return;
    var no = root.querySelector('[data-mh-no]');
    var tot = root.querySelector('[data-mh-tot]');
    var bar = root.querySelector('[data-mh-bar]');
    var prev = root.querySelector('[data-mh-prev]');
    var next = root.querySelector('[data-mh-next]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function stepW() {
      var c = r.querySelector('.mh-prod__card');
      return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(r).columnGap) || 16) : 300;
    }
    function update() {
      var max = r.scrollWidth - r.clientWidth;
      var cards = r.children;
      var total = cards.length;
      /* numarul pozei de la capatul vizibil: cate poze au ajuns cu totul in cadru (geometria fara transformari, ca poza inclinata sa nu conteze) */
      var edge = r.scrollLeft + r.clientWidth + 2;
      var cur = 0;
      for (var i = 0; i < total; i++) { if (cards[i].offsetLeft + cards[i].offsetWidth <= edge) cur = i + 1; }
      cur = Math.max(1, Math.min(total, max <= 0 ? total : cur));
      if (no) no.textContent = pad(cur);
      if (tot) tot.textContent = pad(total);
      if (bar) bar.style.width = (max <= 0 ? 100 : Math.max(8, ((r.scrollLeft + r.clientWidth) / r.scrollWidth) * 100)) + '%';
    }
    function go(dir) { r.scrollBy({ left: dir * w2(), behavior: 'smooth' }); }
    function w2() { return Math.max(stepW() * 2, r.clientWidth * 0.6); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    r.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* video din «Piesa lunii»: se încarcă doar la click și se oprește la închidere */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var open = t.closest('[data-mh-video]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('data-mh-video'));
      var tpl = dlg && dlg.querySelector('template');
      if (!dlg || !tpl || typeof dlg.showModal !== 'function') return;
      if (!dlg.querySelector('.mh-vid__box')) {
        var box = document.createElement('div');
        box.className = 'mh-vid__box';
        box.appendChild(tpl.content.cloneNode(true));
        dlg.appendChild(box);
        var vv = box.querySelector('video');
        if (vv) {
          var setR = function () { if (vv.videoWidth) dlg.style.setProperty('--r', (vv.videoWidth / vv.videoHeight).toFixed(4)); };
          vv.addEventListener('loadedmetadata', setR);
          setR();
        }
      }
      dlg.showModal();
      var v = dlg.querySelector('video');
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      return;
    }
    var close = t.closest('[data-mh-video-close]');
    var d2 = close ? close.closest('dialog') : (t.tagName === 'DIALOG' && t.classList.contains('mh-vid') ? t : null);
    if (d2) d2.close();
  });
  document.addEventListener('close', function (e) {
    var d = e.target;
    if (d && d.classList && d.classList.contains('mh-vid')) {
      var b = d.querySelector('.mh-vid__box');
      if (b) b.remove();
    }
  }, true);

  /* miniatura video: pornește singură, în buclă și fără sunet, doar cât timp se vede; cine are mișcarea redusă o vede oprită, cu buton de play */
  function thumbVideo(v) {
    if (v.__mh) return;
    v.__mh = true;
    var box = v.closest('.th');
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.pause();
      v.removeAttribute('autoplay');
      if (box) box.classList.add('is-still');
      return;
    }
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) play(); else v.pause(); });
      }, { threshold: 0.25 }).observe(v);
    } else play();
  }

  /* «Piesa lunii»: poziția secțiunii pe ecran (de la 1 la intrare până la -1 la ieșire) ajunge în --mh-sp; CSS-ul mută poza din stânga și textul în sensuri opuse */
  function scrollVar(sec, prop) {
    if (sec['__mhp' + prop]) return;
    sec['__mhp' + prop] = true;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    var gain = parseFloat(sec.getAttribute('data-mh-gain') || '2') || 2;
    function upd() {
      ticking = false;
      if (!sec.isConnected) return;
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.bottom < -300 || r.top > vh + 300) return;
      var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
      sec.style.setProperty(prop, Math.max(-1, Math.min(1, p * gain)).toFixed(4));
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }
    document.addEventListener('scroll', req, { passive: true, capture: true });
    window.addEventListener('resize', req);
    upd();
  }

  /* «Cele mai noi»: dacă lângă cuvântul șters rămâne loc alb, textul din dreapta stă acolo (fără să-l acopere); pe ecrane mici rămâne peste cuvânt */
  function prodSide(sec) {
    if (sec.__mhs) return;
    sec.__mhs = true;
    var ghost = sec.querySelector('.mh-prod__ghost');
    var side = sec.querySelector('.mh-prod__side');
    if (!ghost || !side) return;
    function fit() {
      sec.classList.remove('side-free');
      if (window.innerWidth < 1100) return;
      var gr = ghost.getBoundingClientRect();
      var avail = (sec.getBoundingClientRect().right - 18) - (gr.right + 28);
      if (avail >= 210) {
        sec.style.setProperty('--mh-sw', Math.floor(Math.min(avail, 360)) + 'px');
        sec.classList.add('side-free');
      }
    }
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 80); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
  }

  /* galerie: prima poză începe exact după primele litere ale cuvântului șters (implicit 4, adică se vede doar LOOK, fără B) */
  function galLead(sec) {
    if (sec.__mhg) return;
    sec.__mhg = true;
    var ghost = sec.querySelector('.ghost');
    var inner = sec.querySelector('.mh-gal__in');
    var n = parseInt(sec.getAttribute('data-mh-lead') || '0', 10);
    if (!ghost || !inner || !(n > 0)) return;
    function fit() {
      sec.style.removeProperty('--mh-gal-x');
      if (window.innerWidth < 750) return;
      var node = ghost.firstChild;
      if (!node || node.nodeType !== 3 || !node.length) return;
      var r = document.createRange();
      r.setStart(node, 0);
      r.setEnd(node, Math.min(n, node.length));
      var x = r.getBoundingClientRect().right - inner.getBoundingClientRect().left + 3;
      if (x > 0) sec.style.setProperty('--mh-gal-x', Math.round(x) + 'px');
    }
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 80); });
    window.addEventListener('load', fit);
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(fit);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fit);
    }
    /* măsurătoarea e corectă doar când secțiunea e desenată, deci se reface și când ajunge pe ecran */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) fit(); }, { threshold: 0.05 }).observe(sec);
    }
    fit();
  }

  /* banda cu avantaje: durata unei ture = lățimea unui grup / viteza aleasă, ca viteza să fie aceeași oricât text ar fi */
  function marquee(sec) {
    if (sec.__mhq) return;
    sec.__mhq = true;
    var grp = sec.querySelector('.mh-mq__grp');
    var speed = parseFloat(sec.getAttribute('data-mh-speed') || '60') || 60;
    if (!grp) return;
    function fit() {
      var w = grp.getBoundingClientRect().width;
      if (w > 0) sec.style.setProperty('--mh-mqd', (w / speed).toFixed(1) + 's');
    }
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
    window.addEventListener('load', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.mh-mq').forEach(marquee);
    (scope || document).querySelectorAll('.mh-gal').forEach(galLead);
    (scope || document).querySelectorAll('.mh-prod').forEach(prodSide);
    (scope || document).querySelectorAll('.mh-spot').forEach(function (s) { scrollVar(s, '--mh-sp'); });
    (scope || document).querySelectorAll('.mh-col').forEach(function (s) { scrollVar(s, '--mh-cp'); });
    (scope || document).querySelectorAll('.mh-th-vid').forEach(thumbVideo);
    (scope || document).querySelectorAll('[data-mh-slider]').forEach(init);
    (scope || document).querySelectorAll('.mh-hero--par').forEach(parallax);
    (scope || document).querySelectorAll('.mh-hero').forEach(clouds);
    (scope || document).querySelectorAll('[data-mh-railwrap]').forEach(rail);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
